import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { EventsQueryKeys } from '@/modules/events/keys'
import {
	GetTurnoverEventsRequest,
	TurnoverEventListResponse,
} from '@/modules/events/type'
import { getTurnoverEvents } from '../../services'

export default function useQueryGetTurnoverEvents(
	payload: GetTurnoverEventsRequest,
	props?: Omit<
		UseQueryOptions<TurnoverEventListResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) {
	return useQuery<TurnoverEventListResponse>({
		queryKey: [EventsQueryKeys.getTurnoverEvents, payload],
		queryFn: () => getTurnoverEvents(payload),
		...props,
	})
}
